import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { can } from "@/v2/lib/rbac";

export default function ProfileChangePermission({ userId }) {
  const { user, refresh } = useAuth();
  const qc = useQueryClient();
  const [busy, setBusy] = useState(false);
  const manage = can(user, "manage_users");
  const { data } = useQuery({ queryKey: ["admin-employee", userId], enabled: manage,
    queryFn: async () => (await api.get(`/admin/users/${userId}`)).data });
  if (!manage || !data?.user) return null;
  const allowed = !!data.user.profile_change_allowed;
  const toggle = async () => {
    setBusy(true);
    try {
      await api.post(`/admin/users/${userId}/profile-change-permission`, { allowed: !allowed });
      await qc.invalidateQueries({ queryKey: ["admin-employee", userId] });
      if (userId === user.id) await refresh();
      toast.success(allowed ? "أُلغي السماح" : "يمكن للموظف إعادة اختيار مساره مرة واحدة بعد تحديث صفحته");
    } catch (e) { toast.error(e.response?.data?.detail || "تعذر تحديث السماح"); }
    finally { setBusy(false); }
  };
  return <div className="v2-inset p-3 space-y-2" data-testid="profile-change-permission">
    <p className="text-sm">{allowed ? "مسموح بإعادة اختيار المسار مرة واحدة" : "المسار محدد؛ تغييره يتطلب سماح مدير المنصة"}</p>
    <button className="v2-btn-ghost v2-btn-sm" disabled={busy} onClick={toggle}>{allowed ? "إلغاء السماح" : "السماح بإعادة اختيار المسار"}</button>
  </div>;
}
